import { render, staticRenderFns } from "./OrganizationManagement.vue?vue&type=template&id=19f803c9&"
import script from "./OrganizationManagement.vue?vue&type=script&lang=js&"
export * from "./OrganizationManagement.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationManagement.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OrganizationManagement.vue"
export default component.exports